<div class="cna-icons" *ngIf="getCnaListForAccessory(dialogName).length>0">
  <div class="cna-list-item" *ngFor="let item of getCnaListForAccessory(dialogName)">
    <img [src]='getOptionIcon(item)'><span>{{item}}</span>
  </div>
</div>
